<div class="patient-order-details-page">
  <div *ngIf="!loaded" class="order-details-loading">
    <h3 style="text-align: center">LOADING ORDER</h3>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div *ngIf="loaded" class="patient-order-details">
    <div
      class="order-details-toolbar"
      [class.order-details-toolbar-embedded]="embedded"
      [class.priority-redo-header]="isPriorityRedo"
    >
      <button mat-button type="button" (click)="navigateBack()">
        <mat-icon>{{ embedded ? 'close' : 'arrow_back' }}</mat-icon>
        <span>{{ embedded ? 'CLOSE' : 'BACK TO PATIENT' }}</span>
      </button>
      <div class="order-details-toolbar-center">
        <button
          mat-stroked-button
          type="button"
          class="internal-note-button"
          [class.has-note]="hasInternalNote"
          (click)="openInternalNoteDialog()"
        >
          <mat-icon>visibility</mat-icon>
          <span>INTERNAL NOTE</span>
        </button>
      </div>
      <div class="order-details-toolbar-right">
        <span
          class="invoice-number ao-order-number"
          *ngIf="isQuoteDisplay"
        >
          QUOTE
        </span>
        <span
          class="invoice-number ao-order-number"
          *ngIf="!isQuoteDisplay && invoiceNumberDisplay"
        >
          <span class="invoice-number-label">No.</span>
          {{ invoiceNumberDisplay }}
          <span class="redo-badge" *ngIf="isRedoJob">RE-DO</span>
          <span class="return-badge" *ngIf="isReturnJob">RETURN</span>
          <span class="fulfillment-ship-badge" *ngIf="isShipFulfillment">SHIP</span>
        </span>
        <app-linked-job-badge
          [summary]="orderFormGroup?.get('linkSummary')?.value"
          [patientId]="patientId || patient?._id"
        ></app-linked-job-badge>
        <div class="order-status-row">
          <app-log-menu
            [order]="orderFormGroup"
            [small]="true"
            [alwaysShow]="true"
          ></app-log-menu>
          <span class="order-status-button">{{ orderStatusLabel }}</span>
        </div>
        <div class="ack-notice ack-notice-done" *ngIf="acknowledgmentNotice && !needsCustomerAck">
          {{ acknowledgmentNotice }}
        </div>
        <div
          class="ack-notice"
          [class.ack-notice-needed]="superbillNeedsAttention"
          *ngIf="superbillRequested"
        >
          <span *ngIf="superbillNeedsAttention">SUPERBILL — {{ superbillError }}</span>
          <span *ngIf="!superbillNeedsAttention && !canOpenSuperbill">SUPERBILL requested. Emailed when the balance is $0.00.</span>
          <span *ngIf="!superbillNeedsAttention && canOpenSuperbill">SUPERBILL</span>
          <button mat-button type="button" *ngIf="canOpenSuperbill" (click)="viewSuperbill()">VIEW</button>
          <button mat-button type="button" *ngIf="canOpenSuperbill" (click)="printSuperbill()">PRINT</button>
          <button mat-button type="button" *ngIf="canOpenSuperbill" (click)="emailSuperbill()">RE-EMAIL</button>
          <button mat-button type="button" *ngIf="superbillNeedsAttention" (click)="retrySuperbill()">RETRY</button>
        </div>
        <div class="ack-notice ack-notice-needed" *ngIf="needsCustomerAck">
          AWAITING CUSTOMER APPROVAL
          <button mat-button type="button" (click)="onSave('CUSTOMER ACKNOWLEDGEMENT')">
            SIGN NOW
          </button>
          <button mat-button type="button" (click)="onSave('SEND ACKNOWLEDGEMENT')">
            SEND ACKNOWLEDGEMENT
          </button>
        </div>
      </div>
    </div>

    <div
      fxLayout="row"
      fxLayoutAlign="start end"
      fxLayoutGap="10px"
      class="patient-order-header"
      [formGroup]="orderFormGroup"
    >
      <div fxFlex="0 0 75px">PATIENT:</div>
      <div fxFlex="1 1 calc(35%-75px)" class="patient-name">
        {{ patient?.lastName }}, {{ patient?.firstName }}
      </div>
      <div fxFlex="0 0 50px" style="text-align: center">CELL:</div>
      <div fxFlex="1 1 calc(25%-50px)">{{ patient?.cell | phone }}</div>
    </div>

    <mat-accordion class="order-details-accordion" multi>
      <mat-expansion-panel [expanded]="true" (opened)="panelOpenStateFrameDetails = true" (closed)="panelOpenStateFrameDetails = false">
        <mat-expansion-panel-header class="ao-record-head" [class.ao-record-open]="panelOpenStateFrameDetails">
          <mat-panel-title>FRAME DETAILS</mat-panel-title>
        </mat-expansion-panel-header>
        <app-frame-details
          [orderForm]="orderFormGroup"
          [patient]="patient"
          [authorized]="authorized"
          (saveOrder)="onSave($event.destination)"
        ></app-frame-details>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelOpenStatePrescription = true" (closed)="panelOpenStatePrescription = false">
        <mat-expansion-panel-header class="ao-record-head" [class.ao-record-open]="panelOpenStatePrescription">
          <mat-panel-title>PRESCRIPTION</mat-panel-title>
        </mat-expansion-panel-header>
        <app-prescription-details
          [orderForm]="orderFormGroup"
          [patient]="patient"
          (saveOrder)="onSave($event.destination)"
        ></app-prescription-details>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelOpenStateLens = true" (closed)="panelOpenStateLens = false">
        <mat-expansion-panel-header class="ao-record-head" [class.ao-record-open]="panelOpenStateLens">
          <mat-panel-title>LENS</mat-panel-title>
        </mat-expansion-panel-header>
        <app-lens-details
          [orderForm]="orderFormGroup"
          (saveOrder)="onSave($event.destination)"
        ></app-lens-details>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelOpenStateFinancial = true" (closed)="panelOpenStateFinancial = false">
        <mat-expansion-panel-header class="ao-record-head" [class.ao-record-open]="panelOpenStateFinancial">
          <mat-panel-title>FINANCIAL</mat-panel-title>
        </mat-expansion-panel-header>
        <app-payment-details
          [orderForm]="orderFormGroup"
          [patient]="patient"
          (orderUpdated)="onFinancialOrderUpdated($event)"
        ></app-payment-details>
      </mat-expansion-panel>

      <mat-expansion-panel (opened)="panelOpenStateRepair = true" (closed)="panelOpenStateRepair = false">
        <mat-expansion-panel-header class="ao-record-head" [class.ao-record-open]="panelOpenStateRepair">
          <mat-panel-title>REPAIR / WARRANTY</mat-panel-title>
        </mat-expansion-panel-header>
        <app-repair-details
          [orderForm]="orderFormGroup"
          (saveOrder)="onSave($event.destination)"
        ></app-repair-details>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
